import styled from '../../../_snowpack/pkg/styled-components.js';
export const Table = styled.div.withConfig({
  displayName: "table__Table",
  componentId: "sc-1gcel1p-0"
})(["display:flex;flex-direction:column;flex:1;"]);